import React from "react";
import PropTypes from "prop-types";
import pDebounce from "p-debounce";
import { useWatch } from "react-hook-form";
import CacheMap from "../../lib/form/CacheMap";
import Select from "./Select";
import { createTheme } from '@mui/material/styles';
const theme = createTheme({});

const cache = new CacheMap("fetch_r1e_concess");

function R1ESelectConcess({
  methods,
  label,
  name,
  dependOfIdAnnonceur,
  dependOfIdLocalite,
  required,
  variant,
}) {

  const { control } = methods;

  const defaultItem = {
    value: "",
    label: required ? `${label} *` : label,
    disabled: true,
    style: {
      color: theme.palette.text.secondary,
    }
  };

  const [dependOfIdLocaliteValue, dependOfIdAnnonceurValue] = useWatch({
    control,
    name: [dependOfIdLocalite, dependOfIdAnnonceur],
  });


  const fetchData = () => {
    return pDebounce(async (dependOf, dependOfValue, setItems) => {

      if (typeof dependOfValue !== "string") {
        setItems([defaultItem]);
        return undefined;
      }

      const url = `https://cc-acquisition.reserverunessai.com/ws/get/DistributeursConcessForCampaignController/getByLocality/${dependOfIdLocaliteValue}/${dependOfIdAnnonceurValue}`;

      let result;
      if (cache.has(url)) {
        result = cache.get(url);
      } else {
        const response = await fetch(
          url,
          {
            method: "GET",
            headers: {},
            mode: "cors",
            cache: "default",
          }
        );
        result = await response.json();
        cache.set(url, result);
      }

      setItems(
        [
          defaultItem,
          ...result.map(({ nom, option4, iddistributeur }) => ({ label: `${nom} - ${option4}`, value: iddistributeur }))
        ]
      );
    }, 500);
  };


  return (
    <React.Fragment>
      <Select
        name={name}
        label={null}
        required={required}
        variant={variant}
        methods={methods}
        items={[defaultItem]}
        dependOf={dependOfIdAnnonceur}
        dependOfLoader={fetchData()}
        displayEmpty={true}
      />
    </React.Fragment>
  );
}

R1ESelectConcess.defaultProps = {
  label: "Votre concession",
  name: "R1Eiddistributeur",
  dependOfIdLocalite: "idlocalite",
  dependOfIdAnnonceur: "idannonceur",
  required: "Merci de sélectionner votre concession",
  variant: "outlined",
};

R1ESelectConcess.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Label du champ
   */
  label: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Name du tag HTML input contenant l'adresse de l'établissement
   */
  addressName: PropTypes.string,
  /**
   * Id de la localité unique dans R1E
   */
  dependOfIdLocalite: PropTypes.string,
  /**
   * ID de l'annonceur dans R1E
   */
  dependOfIdAnnonceur: PropTypes.string,
  /**
   * Nom du champ de dépendance dans le formulaire
   */
  dependOf: PropTypes.string,
  /**
   * Nom du champ City de dépendance dans le formulaire
   */
  dependOfCity: PropTypes.string,
  /**
   * Message d'erreur si le champ est requis
   */
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * The variant to use
   * 'filled'
   * | 'outlined'
   * | 'standard'
   */
  variant: PropTypes.string,
};

export default R1ESelectConcess;
